import { useQueryClient } from "@tanstack/react-query";

import { AtsJobResponse } from "@/types";

export const useSetAtsJobs = () => {
  const queryClient = useQueryClient();
  return ({
    atsJobs,
  }: {
    atsJobs: AtsJobResponse[];
  }) => {
    queryClient.setQueryData(
      ["orphaned-ats-jobs"],
      atsJobs,
    );
  };
};
